import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBOQGwb-muRLlJ6AK2YZbkSHNRvLga5-Y8",
  authDomain:"excellalaiyontadmin.firebaseapp.com",
  projectId: "excellalaiyontadmin",
  storageBucket: "excellalaiyontadmin.firebasestorage.app",
  messagingSenderId: "193955454415",
  appId: "1:193955454415:web:c6685bc2c11487252a46ba",
  measurementId: "G-WWF5D2BLTX",
};

// apiKey: "AIzaSyBLZSmC8RSfUAbyAE2sy1Y1NWsUFvuvaM0",
// authDomain: "excellalaiyont-65041.firebaseapp.com",
// projectId: "excellalaiyont-65041",
// storageBucket: "excellalaiyont-65041.firebasestorage.app",
// messagingSenderId: "257106544836",
// appId: "1:257106544836:web:6e0f8b8389136529e3a191",
// measurementId: "G-Y0EM6DXTRH"

measurementId: "G-WWF5D2BLTX";
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };
